import { either, equals, pipe } from 'ramda'

import { getEnvs } from './env'

export const ENABLED = 'enabled'
export const DISABLED = 'disabled'
export const DEMO = 'enabled-demo'

const modes = [ENABLED, DISABLED, DEMO]

export const ANOMALY = 'anomaly'
export const CLASSIFICATION = 'classification'
export const SEGMENTATION = 'segmentation'
export const PATCH = 'classification_patch'

const modeOrDisabled = (mode: string | undefined) => {
  if (!mode) return DISABLED
  if (modes.includes(mode)) return mode
  return DISABLED
}

export const checkProductMode = (productType: string | undefined): string => {
  const {
    productModes: { anomaly, classification, segmentation, patch },
  } = getEnvs()

  return modeOrDisabled(
    (() => {
      if (productType === ANOMALY) return anomaly
      if (productType === CLASSIFICATION) return classification
      if (productType === SEGMENTATION) return segmentation
      if (productType === PATCH) return patch
      return DISABLED
    })()
  )
}

export const isProductEnabled = pipe(checkProductMode, equals(ENABLED))

export const isProductDemo = pipe(checkProductMode, equals(DEMO))

export const isProductDisabled = pipe(checkProductMode, equals(DISABLED))

export const isProductEnabledOrDemo = either(isProductEnabled, isProductDemo)
